import { datadogRum } from "@datadog/browser-rum";
import * as Sentry from "@sentry/nextjs";
import { Chatbot } from "@zapier/chatbots-tailwind/dist/types";

export const handleChatbotError = (error: unknown, _chatbot?: Chatbot) => {
  const errorMessage = error instanceof Error ? error.message : String(error);

  datadogRum.addError(`Chat response error: ${errorMessage}`);
  Sentry.captureException(error);
};
